import styled from 'styled-components';
import { devices } from "../data/constants";

export const ZipCodeManagerStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ZipCodeEnterStyled = styled.div`
    display: flex;
`;

export const ZipCodeSelectionStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ZipCodeButtonContainerStyled = styled.div`
    display: flex;
    align-items: center;
`;

export const ZipSelectStyled = styled.select `
    width: 150px;
    height: 96px;
    font-size: 16px;
    border-radius: 8px;
    border: ${({ theme }) => theme.colors.borderColor} 1px solid;
    margin: 8px 0px;
    &:checked {
        background-color: ${({ theme }) => theme.colors.lightActiveHover};
    }
    &:focus {
        outline: none !important;
        border: 1.5px solid ${({ theme }) => theme.colors.contrastText};
    }
    @media only screen and ${devices.md} {
        width: 50%;
    }
`;

export const StatusMessageAreaStyled = styled.div `
    border: 1px solid #007BFF;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.lightActiveHover};
    padding: 10px;
    margin-top: 12px;
    max-height: 150px;
    overflow-y: auto;
    font-size: 13px;
    color: #333;
`;
